import React, {Suspense, useEffect, useState} from "react";
import {BrowserRouter as Router, Routes, Route, useParams} from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "./index.css";
import Loader from "./components/Loader";
import Villa_Magic from "./components/property/Villa_Magic";
import axios from "axios";
import BASE from "./config";
import HowToBook from "./pages/HowToBook";
import { DefaultSeo } from "./components/Seo";

// Lazy load the page components
const Home = React.lazy(() => import("./pages/Home"));
const Property = React.lazy(() => import("./pages/Property"));
const Resorts = React.lazy(() => import("./pages/Resorts"));
const Vale_do_Lobo = React.lazy(() => import("./pages/Vale_do_Lobo"));
const FaQ = React.lazy(() => import("./pages/Faq"));
const About = React.lazy(() => import("./pages/About"));
const Contact = React.lazy(() => import("./pages/Contact"));
const Search = React.lazy(() => import("./pages/Search"));
const Terms_Conditions = React.lazy(() => import("./pages/Terms-and-Conditions"));
const Privacy_Policy = React.lazy(() => import("./pages/Privacy_Policy"));

const App = () => {


  return (
    <HelmetProvider>
      <Router>
        <DefaultSeo />
        {/*<Suspense fallback={<Loader/>}>*/}
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/property" element={<Property />} />
            <Route path="/resorts" element={<Resorts />} />
            <Route path="/:slug/:id" element={<Vale_do_Lobo />} />
            <Route path="/:slug1/:slug2/:id" element={<Property />} />
            {/*<Route path="/vale_do_lobo" element={<Vale_do_Lobo />} />*/}
            <Route path="/faq" element={<FaQ />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/search" element={<Search />} />
            <Route path="/terms-and-conditions" element={<Terms_Conditions />} />
            <Route path="/privacy_policy" element={<Privacy_Policy />} />
            <Route path="/how-to-book" element={<HowToBook />} />
          </Routes>
        {/*</Suspense>*/}
      </Router>
    </HelmetProvider>
  );
};

export default App;